import styled from 'styled-components';
import { A } from 'components/Typography';
import Container from 'components/Container';

export const PoliciesContainer = styled(Container)`
  color: white;
`;

export const Policy = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
`;

export const PolicyName = styled(A)`
  margin: 0 24px;
`;

export const Product = styled.div`
  padding: 24px 0;
`;
